import React from 'react';
import Fade from 'react-reveal/Fade';
import PropTypes from 'prop-types';

const GalleryTitle = ({ title }) => (
    <Fade bottom>
        <h2 className="font-arapey tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 leading-12">{title}</h2>
    </Fade>
);

GalleryTitle.propTypes = {
    title: PropTypes.string.isRequired,
};

export default GalleryTitle;
